// Isomorphic Router - runs in both Node and Browser
// Pure pattern matching, no I/O, no filesystem

import 'urlpattern-polyfill';

export class Router {
	static TYPES = {
		CONTROLLER: 1,
		FUNCTION: 2,
		DIRECT: 3,
		FILE: 4,
		DIRECTORY: 5,
		DATA_URL: 6,
	};

	routes = [];

	constructor(routes = []) {
		this.routes.push(...routes);
	}

	/**
	 * Register a route. This is the low-level method — just stores the config.
	 * Server-specific or project-specific registration methods can wrap this.
	 */
	register(route) {
		this.routes.push(route);
		this.sort();
	}

	/**
	 * Match a URL against all registered routes.
	 * Returns the first matching route with parsed segments and pattern groups, or null.
	 * Pure function — no I/O.
	 */
	process(url) {
		let result = null;
		for (const data of this.routes) {
			if (!data.pattern) {
				data.pattern = new URLPattern({ pathname: data.rule });
			}
			if (data.pattern.test(url)) {
				result = {
					...data,
					result: data.pattern.exec(url),
				};
				result.segments = result.result.pathname.input.split('/');
				result.segments.shift(); // remove empty root
				result.patterns = result.result.pathname.groups;
				break;
			}
		}
		return result;
	}

	sort() {
		for (const i in this.routes) {
			const route = this.routes[i];
			if (route.index === -1) {
				this.routes.push(route);
				this.routes.splice(i, 1);
			}
		}
	}

	/**
	 * Serialize route table for client-side use (PWA/Capacitor).
	 * Strips server-only properties (provider paths, view paths, etc.)
	 * and keeps only what the client needs for matching.
	 */
	serialize() {
		return this.routes
			.filter(r => r.type === Router.TYPES.CONTROLLER)
			.map(r => ({
				rule: r.rule,
				type: r.type,
				crate: r.crate,
				component: r.component,
				frontendHandler: r.frontendHandler,
				controller: r.controller,
			}));
	}
}

export default Router;
